import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DataLayerModule } from '../../common/datalayer/datalayer.module';
import { FlyoutFeedComponent } from '../../flyout/flyout-feed/flyout-feed.component';
import { FlyoutFeedModule } from '../../flyout/flyout-feed/flyout-feed.module';
// This Module's Components
import { NotificationComponent } from './notification.component';

@NgModule({
  imports: [
    CommonModule,
    DataLayerModule,
    FlyoutFeedModule,
    ModalModule.forRoot()
  ],
  declarations: [NotificationComponent],
  exports: [NotificationComponent]
})
export class NotificationModule {}
